import styled from 'styled-components'

export const CustomButton = styled.button`
  padding-top: 0.4375rem !important;
  padding-bottom: 0.4375rem !important;
  border-color: var(--input-border-color) !important;

  svg {
    padding: 0 2px;
    width: 1.25rem;
    height: 1.625rem;
  }
`

CustomButton.displayName = 'CustomButton'
